/**
 * Tour guide — Section Coffre-fort (Vault)
 */

const vaultTour = [
  {
    target: '[data-tour="vault-folders"]',
    title: 'Arborescence de dossiers',
    content: 'Les secrets sont rangés par société puis par dossier. Choisissez la société avec le filtre en haut du portail : ses dossiers s\'affichent ici. Glissez un secret sur un dossier pour l\'y ranger.',
    position: 'right',
  },
  {
    target: '[data-tour="vault-list"]',
    title: 'Liste des secrets',
    content: 'Chaque ligne montre le nom, la société, l\'identifiant, le mot de passe masqué, le poste affecté, l\'URL, les tags, la sensibilité et la date de modification ; l\'icône donne la catégorie. Un clic ouvre le détail, un double-clic copie le mot de passe.',
    position: 'top',
  },
  {
    target: '[data-tour="vault-search"]',
    title: 'Recherche',
    content: 'Recherchez par nom, identifiant, URL, e-mail, tags, description ou poste affecté. Les filtres Sensibilité, Catégorie et Statut, au-dessus de la liste, affinent les résultats.',
    position: 'bottom',
  },
  {
    target: null,
    title: 'Niveaux de sensibilite',
    content: '4 niveaux de securite croissants :\n\n• Standard — Affichage 2 min, copie OK\n• Sensible — Affichage 1 min, copie OK\n• Critique — MFA requis, affichage 30 sec\n• Ultra-critique — MFA requis, copie bloquee, 15 sec, restrictions IP/horaires\n\nLe niveau determine les controles de securite appliques a chaque acces.',
    position: 'bottom',
  },
  {
    target: null,
    title: 'Audit complet',
    content: 'Chaque consultation, copie ou modification est tracee avec l\'auteur et l\'horodatage. Le superadmin peut consulter les logs d\'audit par societe.',
    position: 'bottom',
  },
];

export default vaultTour;
